import { render, staticRenderFns } from "./CatalogRestoreConfirmModal.vue?vue&type=template&id=cb26582c&"
import script from "./CatalogRestoreConfirmModal.vue?vue&type=script&lang=js&"
export * from "./CatalogRestoreConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports